import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '../../../../uikit/info/Modal';
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
import { Spacer } from '../../../../uikit/misc/Spacer';
import Spinner from '../../../../uikit/misc/Spinner';
var t = getTranslation(translations);
export default function PageSubmittingModal(_a) {
    var isOpen = _a.isOpen;
    return (React.createElement(Modal, { open: isOpen },
        React.createElement(Box, { display: "flex", justifyContent: "center" },
            React.createElement(Spinner, null)),
        React.createElement(Spacer, { size: 3 }),
        React.createElement(Typography, { variant: "body1", textAlign: "center" }, t.title),
        React.createElement(Spacer, { size: 1 }),
        React.createElement(Typography, { variant: "body2", textAlign: "center" }, t.content),
        React.createElement(Spacer, { size: 2 })));
}
